import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import { AppContent } from 'components';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useBizLogicActions, useSystemActions, useUserActions } from 'stores';
import VConsole from 'vconsole';

function App() {
	const { t } = useTranslation();
	const { getImage, getCurrentPosition, setSDKMode } = useSystemActions();
	const { setEntryCode } = useBizLogicActions();
	const { setOpenToken } = useUserActions();
	const [searchParams] = useSearchParams();

	useEffect(() => {
		setSDKMode(searchParams.get('sdkMode'));
		setEntryCode({
			uaid: searchParams.get('u'),
			type: searchParams.get('t'),
		});
		setOpenToken(searchParams.get('openToken'));
		if (Boolean(searchParams.get('console'))) {
			new VConsole();
		}
	}, []);

	//	Webscan initialization, get GPS
	useEffect(() => {
		getCurrentPosition().then();
	}, []);

	//	Reset title everytime App rerender, this will modify title when locale changes.
	useEffect(() => {
		document.title = t('default.title');
	});

	return (
		<>
			<Container
				disableGutters
				sx={{
					width: '100vw',
					maxWidth: '600px !important',
					height: 'var(--dynamic-viewport-height)',
					backgroundColor: 'background.default',
					backgroundImage:
						process.env.REACT_APP_CUSTOM_TEXTURE &&
						`url(${getImage(
							process.env.REACT_APP_CUSTOM_TEXTURE
						)})`,
				}}
			>
				<CssBaseline />
				<AppContent />
			</Container>
		</>
	);
}

export default App;
